import { Dropdown } from 'tailwindcss-stimulus-components';

export default class DropdownPrevent extends Dropdown {
  show(event) {
    event.preventDefault();
    this.closeOtherDropdowns();
    super.show();
  }

  toggle(event) {
    !this.openValue && event.preventDefault();
    if (!this.openValue) {
      this.closeOtherDropdowns();
    }
    super.toggle();
  }

  closeOtherDropdowns() {
    // Close all other open dropdowns
    document.querySelectorAll('[data-controller~="dropdown"]').forEach((el) => {
      if (el !== this.element) {
        const menu = el.querySelector('[data-dropdown-target="menu"]');
        if (menu && !menu.classList.contains('hidden')) {
          menu.classList.add('hidden');
        }
      }
    });
  }
}
